// container width + 32px padding (l+r)
module.exports = {
  sm: '736px',
  md: '920px',
  lg: '1104px',
}
